module.exports = __webpack_public_path__ + "static/mictic-9952463ed55ccb55812e0fa43674e55c.jpg";